<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;">Expériences </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> Expériences</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
    <div class="container mb-5">


        <section class="row justify-content-center">
            <!-- Button to go back apply job -->
            <div class="col-md-4" *ngIf="showBtnToGoApplyJob">
                <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning">Retour vers la page d'emploi</a>
            </div>
        </section>

        <section class="row justify-content-center">

            <div class="col-md-11 mb-5">
                <fieldset class="form-area fieldset-panel">
                    <legend class="legend-style" style="width: 30%;">Experiences </legend>

                    <form id="" [formGroup]="experiencesForm" (ngSubmit)="onSubmitExperienceForm()"
                        style="display: block">
                        <input type="text" class="form-control h-40px text-uppercase" id="candidate_experience_id"
                            formControlName="candidate_experience_id" hidden>
                        <div class="form-group">
                            <label for="job_title">Titre du poste <span class="star-style">**</span></label>
                            <input type="text" class="form-control h-40px text-uppercase" id="job_title"
                                formControlName="job_title">
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="periodStartJob">Date début/Mois <span class="star-style">**</span></label>
                                <select class="form-control" id="periodStartJob" formControlName="month_start">
                                    <option value="">Selectionner...</option>
                                    <option value="01">Janvier</option>
                                    <option value="02">Février</option>
                                    <option value="03">Mars</option>
                                    <option value="04">Avril</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Juin</option>
                                    <option value="07">Juillet</option>
                                    <option value="08">Aôut</option>
                                    <option value="09">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </select>

                                <!-- <input type="number" step="1" min="1900" class="form-control h-40px"
                                        style="width: 40%;" formControlName="year_start"> -->
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodStartJob">Date début/Année <span class="star-style">**</span></label>
                                <select class="form-control" id="year" formControlName="year_start">
                                    <option value="1984">1984</option>
                                    <option value="1985">1985</option>
                                    <option value="1986">1986</option>
                                    <option value="1987">1987</option>
                                    <option value="1988">1988</option>
                                    <option value="1989">1989</option>
                                    <option value="1990">1990</option>
                                    <option value="1991">1991</option>
                                    <option value="1992">1992</option>
                                    <option value="1993">1993</option>
                                    <option value="1994">1994</option>
                                    <option value="1995">1995</option>
                                    <option value="1996">1996</option>
                                    <option value="1997">1997</option>
                                    <option value="1998">1998</option>
                                    <option value="1999">1999</option>
                                    <option value="2000">2000</option>
                                    <option value="2001">2001</option>
                                    <option value="2002">2002</option>
                                    <option value="2003">2003</option>
                                    <option value="2004">2004</option>
                                    <option value="2005">2005</option>
                                    <option value="2006">2006</option>
                                    <option value="2007">2007</option>
                                    <option value="2008">2008</option>
                                    <option value="2009">2009</option>
                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>

                            <div class="form-group col-md-4 my-auto">
                                <input type="checkbox" id="experienceInProgress"
                                    (click)="functionsService.showOrHideEndDate('experienceDateFin', 'experienceInProgress', true)"
                                    checked>
                                <label for="experienceInProgress" style="margin-left: 5px"
                                    (click)="functionsService.showOrHideEndDate('experienceDateFin', 'experienceInProgress', false)">En
                                    cours</label>
                            </div>
                        </div>
                        <div id="experienceDateFin" style="display: none">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="periodEndJob">Date Fin/Mois</label>
                                    <select class="form-control" id="periodEndJob" formControlName="month_end">
                                        <option value="">Selectionner...</option>
                                        <option value="01">Janvier</option>
                                        <option value="02">Février</option>
                                        <option value="03">Mars</option>
                                        <option value="04">Avril</option>
                                        <option value="05">Mai</option>
                                        <option value="06">Juin</option>
                                        <option value="07">Juillet</option>
                                        <option value="08">Aôut</option>
                                        <option value="09">Septembre</option>
                                        <option value="10">Octobre</option>
                                        <option value="11">Novembre</option>
                                        <option value="12">Décembre</option>
                                    </select>

                                </div>
                                <div class="form-group col-md-4">
                                    <label for="periodStartJob">Date début/Année <span
                                            class="star-style"></span></label>
                                    <select class="form-control" id="year" formControlName="year_end">
                                        <option value="1984">1984</option>
                                        <option value="1985">1985</option>
                                        <option value="1986">1986</option>
                                        <option value="1987">1987</option>
                                        <option value="1988">1988</option>
                                        <option value="1989">1989</option>
                                        <option value="1990">1990</option>
                                        <option value="1991">1991</option>
                                        <option value="1992">1992</option>
                                        <option value="1993">1993</option>
                                        <option value="1994">1994</option>
                                        <option value="1995">1995</option>
                                        <option value="1996">1996</option>
                                        <option value="1997">1997</option>
                                        <option value="1998">1998</option>
                                        <option value="1999">1999</option>
                                        <option value="2000">2000</option>
                                        <option value="2001">2001</option>
                                        <option value="2002">2002</option>
                                        <option value="2003">2003</option>
                                        <option value="2004">2004</option>
                                        <option value="2005">2005</option>
                                        <option value="2006">2006</option>
                                        <option value="2007">2007</option>
                                        <option value="2008">2008</option>
                                        <option value="2009">2009</option>
                                        <option value="2010">2010</option>
                                        <option value="2011">2011</option>
                                        <option value="2012">2012</option>
                                        <option value="2013">2013</option>
                                        <option value="2014">2014</option>
                                        <option value="2015">2015</option>
                                        <option value="2016">2016</option>
                                        <option value="2017">2017</option>
                                        <option value="2018">2018</option>
                                        <option value="2019">2019</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                    </select>
                                </div>
                            </div>

                        </div>



                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="company">Nom de l'entreprise <span class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="company"
                                    formControlName="company">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="area_activity">Secteur d'activité <span class="star-style">**</span></label>
                                <select class="form-control" id="area_activity" formControlName="area_activity_id">
                                    <option value="" selected>Selectionner...</option>
                                    <option [value]="areaActivity.getId()"
                                        *ngFor="let areaActivity of areaActivityList">{{
                                        areaActivity.getLibelle() }}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-4">
                                <label for="positionLevel">Niveau de profil <span class="star-style">**</span></label>
                                <select class="form-control" id="positionLevel" formControlName="position_level">
                                    <option value="">Selectionner...</option>
                                    <option value="Stagiaire/Etudiant">Stagiaire/Etudiant</option>
                                    <option value="Jeune diplômé">Jeune diplômé</option>
                                    <option value="Débutant/Junior">Débutant/Junior</option>
                                    <option value="Confirmé/Expérimenté">Confirmé/Expérimenté</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="team_management">Management d'équipe</label>
                                <select class="form-control" id="team_management" formControlName="team_management">
                                    <option value="">Selectionner...</option>
                                    <option value="Aucun">Aucun</option>
                                    <option value="1 à 2 personnes">1 à 2 personnes</option>
                                    <option value="3 à 5 personnes">3 à 5 personnes</option>
                                    <option value="6 à 10 personnes">6 à 10 personnes</option>
                                    <option value="Plus de 10 personnes">Plus de 10 personnes</option>
                                </select>
                            </div>

                            <div class="form-group col-md-4">
                                <label for="supervisor_title">Titre supérieur N + 1 <span
                                        class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="supervisor_title"
                                    formControlName="supervisor_title">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="reason_for_leaving">Motif de départ</label>
                                <select class="form-control" id="reason_for_leaving"
                                    formControlName="reason_for_leaving">
                                    <option value="">Selectionner...</option>
                                    <option value="Départ volontaire">Départ volontaire</option>
                                    <option value="Fin de contrat">Fin de contrat</option>
                                    <option value="Licenciement">Licenciement</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="certificate">Certificat de travail<span
                                        style="font-size: 10px; font-weight: 700;">(pdf, < 1Mo)</span>
                                </label>
                                <span class="form-control h-40px btn btn-success"
                                    (click)="chooseAttestation()">Fichier</span><span *ngIf="attestationFile != null"
                                    style="font-size: 10px; font-weight: 700; color: green"> Super!
                                    Fichier joint</span>
                            </div>

                            <div class="form-group col-md-4">
                                <label for="task">Résumé de la responsabilité <span class="star-style">**</span></label>
                                <textarea class="form-control" id="task" rows="4"
                                    formControlName="task_description"></textarea>
                            </div>

                            <div class="form-group col-md-4">
                                <label for="work">Réalisation <span class="star-style">**</span></label>
                                <textarea class="form-control" id="work" rows="4"
                                    formControlName="work_description"></textarea>
                            </div>

                        </div>
                        <button type="submit" class="primary-btn text-white" [disabled]="experiencesForm.invalid"
                            *ngIf="!experienceIsLoading">Mettre à jour </button>
                        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                            *ngIf="experienceIsLoading">
                            Veuillez
                            patienter...
                        </p>
                    </form>`
                </fieldset>
                <div class="row justify-content-center mt-5">
                    <button class="btn btn-outline-warning col-md-2 mr-2" routerLink="/candidat-trainings">Retour
                    </button>
                    <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning mr-2">Retour vers la page
                        d'emploi</a>
                    <button class="btn btn-primary col-md-6" routerLink="/candidat-software"> Cliquez ici pour
                        ajouter vos Connaissances informatique
                    </button>
                </div>
            </div>

        </section>
    </div>
</section>